import * as api from '@/http'
import * as storage from '@/global/storage.js'
import router from '@/router'

export const ActionLogin = async ({ dispatch }, payload) => {
  dispatch('ui/ActionSetLoading', true, { root: true })
  // dispatch('ActionSetProcess', true)
  dispatch('ActionSetErrorMessage', false)
  dispatch('ActionSetSuccessMessage', false)
  dispatch('ActionSetEmail', payload.email)
  dispatch('ActionSetPassword', payload.password)

  const user = await api.http.post('login/dp', payload).then((response) => response)
  // if (user.status === 200) {
  dispatch('ActionSetProcess', false)
  dispatch('ActionSetSuccessMessage', true)
  dispatch('ActionSetErrorMessage', false)
  dispatch('ActionSetEmail', '')
  dispatch('ActionSetPassword', '')
  dispatch('ActionSetUser', user.data.user)
  dispatch('ActionSetToken', user.data.access_token)
  dispatch('utils/ActionSetUtils', {}, { root: true })
  dispatch('utils/ActionSetUtils', {}, { root: true })
  dispatch('employees/ActionSetBirthdays', {}, { root: true })
  dispatch('employees/ActionSetContactMessageWebSite', {}, { root: true })
  dispatch('employees/ActionSetEmployees', {}, { root: true })
  dispatch('employees/ActionGetPaycheckEmployee', {}, { root: true })
  dispatch('employees/ActionSetScales', {}, { root: true })
  dispatch('employees/ActionSetIncomeTaxes', {}, { root: true })
  dispatch('ci/ActionSetSendedIC', {}, { root: true })
  dispatch('ci/ActionSetReceivedIC', {}, { root: true })
  dispatch('ci/ActionSetAllIC', {}, { root: true })
  setTimeout(() => {
    dispatch('ActionSetSuccessMessage', false)
    setTimeout(() => {
      return router.push('/')
    }, 500)
  }, 2000)
  // } else {
  //   dispatch('ActionSetProcess', false)
  //   dispatch('ActionSetSuccessMessage', false)
  //   dispatch('ActionSetErrorMessage', true)
  //   dispatch('ActionSetPassword', '')
  //   throw user
  // }
  dispatch('ui/ActionSetLoading', false, { root: true })
}

export const ActionCheckToken = ({ dispatch, state }) => {
  if (state.token) {
    return Promise.resolve(state.token)
  }

  const token = storage.GetLocalToken()

  if (!token) {
    return Promise.reject(new Error('Token Inválido'))
  }

  dispatch('ActionSetToken', token)
  return dispatch('ActionProfile')
}

export const ActionProfile = async ({ dispatch, state }) => {
  try {
    if (storage.GetLocalToken() && state.token) {
      const user = await api.http.get('dash/profile')
      dispatch('ActionSetUser', user.data)
    } else {
      return dispatch('ActionSignOut')
    }
  } catch (error) {
    return dispatch('ActionSignOut')
  }
}

export const ActionSetSuccessMessage = ({ commit }, payload) => {
  commit('SET_success_message', payload)
}

export const ActionSetErrorMessage = ({ commit }, payload) => {
  commit('SET_error_message', payload)
}

export const ActionSetProcess = ({ commit }, payload) => {
  commit('SET_process', payload)
}

export const ActionSetEmail = ({ commit }, payload) => {
  commit('SET_email', payload)
}

export const ActionSetPassword = ({ commit }, payload) => {
  commit('SET_password', payload)
}

export const ActionSetUser = ({ commit }, payload) => {
  commit('SET_user', payload)
}

export const ActionSetToken = ({ commit }, payload) => {
  storage.SetLocalToken(payload)
  storage.SetHeaderToken(payload)
  commit('SET_token', payload)
}

export const ActionSignOut = async ({ dispatch }) => {
  try {
    const logout = await api.http.get('logout/')
    if (logout.status === 200) {
      storage.SetHeaderToken('')
      storage.DeleteLocalToken()
      dispatch('ActionSetUser', {})
      dispatch('ActionSetToken', '')
      router.push('/auth')
    }
  } catch (erro) {
    storage.SetHeaderToken('')
    storage.DeleteLocalToken()
    dispatch('ActionSetUser', {})
    dispatch('ActionSetToken', '')
    router.push('/auth')
  }
}

export const ActionDialodPermissionDenied = ({ commit }, payload) => {
  payload = true
  commit('SET_DialodPermissionDenied', payload)
}

export const ActionResendCode = ({ state }) => {
  const response = api.http
    .post('authcode/resend', { email: state.email, from: 'Departamento Pessoal' })
    .then((response) => response.data)
}
